import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { SettingsDynamicUrlLinkButtonV1Field } from "../settings-dynamic-url-link-button-v1.class";
import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown, FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';
import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';

@Component({
    selector: 'form-field-settings-dynamic-url-link-button-v1',
    templateUrl: './settings-dynamic-url-link-button-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsDynamicUrlLinkButtonV1FieldComponent implements OnInit, OnChanges {
    @Input() field: SettingsDynamicUrlLinkButtonV1Field;
    @Output() fieldChange = new EventEmitter<SettingsDynamicUrlLinkButtonV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the Dynnamic Url Link Button";
    public form: FormGroup = new FormGroup({});
    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown, FieldsMenuMoveUp];
    public valid: boolean = false;
    
    private readonly PROJECT_PATTERN = '{PROJECTID}';
    private readonly FORM_PATTERN = '{FORMID}';
    
    get isProjectIdAdded(): boolean {
        return this.field?.url?.includes(this.PROJECT_PATTERN) ?? false;
    }

    get isFormIdAdded(): boolean {
        return this.field?.url?.includes(this.FORM_PATTERN) ?? false;
    }
    
    constructor(private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.field) {
            this.cdr.markForCheck();
        }
    }

    onAvailableOnViewChange(availableOnView: boolean) {
        this.field = this.field.update({ view: availableOnView });
        this.emit(this.field);
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText }));
    }

    onMenuClick(key: string) {
        switch (key) {
            case "confirmation-remove":
                this.fieldMenu = [FieldsMenuMoveDown, FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case "dismiss-really-remove":
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown, FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = { key: key, field: this.field }
                this.menuClick.emit(itemClicked);
        }
    }

    onUrlChange(urlValue: string) {
        
        this.field = this.field.update({ url: urlValue });
        // Force recalc & refresh view
        this.cdr.markForCheck();
        this.emit(this.field);

    }

    addProjectId(): void {
        if (!this.isProjectIdAdded) {
            this.onUrlChange((this.field.url || '') + this.PROJECT_PATTERN);
            this.emit(this.field);
        }
    }

    addFormId(): void {
        if (!this.isFormIdAdded) {
            this.onUrlChange((this.field.url || '') + this.FORM_PATTERN);
            this.emit(this.field);
        }
    }

    private emit(updatedField: SettingsDynamicUrlLinkButtonV1Field): void {
        this.fieldChange.emit(updatedField);
    }

}